export default __webpack_public_path__ + "static/media/malek.b924253f.png";